import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export async function exportElementToPdf(element, fileName, opts = {}) {
  if (!element) throw new Error("exportElementToPdf: missing element");

  const {
    marginMm = 10,
    orientation = "portrait",
    scale = Math.min(window.devicePixelRatio || 1, 2) * 2,
    hideSelectors = ['[data-hide-on-export="true"]'],
  } = opts;

  const hiddenEls = [];
  hideSelectors.forEach((sel) => {
    element.querySelectorAll(sel).forEach((el) => {
      hiddenEls.push([el, el.style.visibility]);
      el.style.visibility = "hidden";
    });
  });

  if (document.fonts && document.fonts.ready) {
    try {
      await document.fonts.ready;
    } catch {}
  }

  await new Promise((r) => requestAnimationFrame(() => r()));

  const canvas = await html2canvas(element, {
    scale,
    useCORS: true,
    backgroundColor: "#ffffff",
    logging: false,
    windowWidth: document.documentElement.clientWidth,
  });

  hiddenEls.forEach(([el, prev]) => {
    el.style.visibility = prev;
  });

  const pdf = new jsPDF({
    orientation,
    unit: "mm",
    format: "a4",
    compress: true,
  });
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const printableWidth = pageWidth - marginMm * 2;
  const printableHeight = pageHeight - marginMm * 2;

  const pxPerMm = canvas.width / printableWidth;
  const pageHeightPx = Math.floor(printableHeight * pxPerMm);

  let renderedPages = 0;
  for (let y = 0; y < canvas.height; y += pageHeightPx) {
    const pageCanvas = document.createElement("canvas");
    pageCanvas.width = canvas.width;
    pageCanvas.height = Math.min(pageHeightPx, canvas.height - y);

    const ctx = pageCanvas.getContext("2d");
    ctx.drawImage(
      canvas,
      0,
      y,
      canvas.width,
      pageCanvas.height,
      0,
      0,
      canvas.width,
      pageCanvas.height
    );

    const imgData = pageCanvas.toDataURL("image/png");
    if (renderedPages > 0) pdf.addPage();

    const sliceHeightMm = pageCanvas.height / pxPerMm;

    pdf.addImage(
      imgData,
      "PNG",
      marginMm,
      marginMm,
      printableWidth,
      sliceHeightMm
    );
    renderedPages++;
  }

  pdf.save(fileName || "export.pdf");
}
